// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2prD6","content":"styles_content__nQGud","selectAll":"styles_selectAll__BK5qr"};